const API_BASE_URL = process.env.BUN_PUBLIC_API_BASE_URL;

export const endpoint = {

  // Auth
  login: `${API_BASE_URL}/api/v1/auth/login/`,
  logout: `${API_BASE_URL}/api/v1/auth/logout/`,

  // Users
  createUser: `${API_BASE_URL}/api/v1/users/`,
  getUsers: `${API_BASE_URL}/api/v1/users/`,
  updateUser: (userId: number) => `${API_BASE_URL}/api/v1/users/${userId}/`,
  
  // Uploads
  uploadProfilePhoto: `${API_BASE_URL}/api/v1/uploads/profile-photo/`,
  uploadFile: `${API_BASE_URL}/api/v1/uploads/file/`,

  // Payments
  createPayment: `${API_BASE_URL}/api/v1/payments/`,
  getUserPayments: (userId: number) => `${API_BASE_URL}/api/v1/payments/?user_id=${userId}`,
  getPaymentsManagement: `${API_BASE_URL}/api/v1/payments/management/`,
} as const;
